import {
    Fragment,
    useMemo,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IStepperItemProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    StepperPartContentProps,
    StepperItemContextType
} from "../../type";
import {
    StepperItemContext,
    withStepperContext
} from "../../context";
import StepperConnector from "../connector";
import StepperPanel from "../panel";
import StepperStep from "../step";

const StepperItemContent: FC<StepperPartContentProps<IStepperItemProps>> = ({
    customTheme: customThemeProp,
    children,
    context,
    index,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context.customTheme);

    const resolvedStep = context.steps[index];

    const isLast = index === context.steps.length - 1;

    const {
        container: containerDynamicStyle
    } = useStyles({
        orientation: context.orientation,
        spaces
    });

    const item = useMemo<StepperItemContextType | undefined>(() => resolvedStep ? {
        ...resolvedStep,
        isLast
    } : undefined, [
        resolvedStep,
        isLast
    ]);

    if(!item) {
        return null;
    }

    const renderDefaultLayout = () => {
        if(context.orientation === "vertical") {
            return <Fragment>
                <StepperStep />
                <StepperPanel />
            </Fragment>;
        }

        return <Fragment>
            <StepperStep />
            {
                isLast ?
                    null
                :
                    <StepperConnector />
            }
        </Fragment>;
    };

    return <StepperItemContext.Provider
        value={item}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container,
                stylesheet[context.orientation],
                context.orientation === "horizontal" && !isLast ? stylesheet.grow : stylesheet.fixed,
                containerDynamicStyle
            ]}
            role="listitem"
        >
            {children ?? renderDefaultLayout()}
        </View>
    </StepperItemContext.Provider>;
};
export default withStepperContext("Item", StepperItemContent);
